import React from 'react'
import { connect } from 'react-redux'
import { AppState } from '../../../reducers'
import { ComplaintCount } from '../../../models/ComplaintCount'
import NavItem, { NavItemProps } from '../../Layout/NavItem'

interface ComplaintNavItemProps {
  complaintCount?: ComplaintCount
}

const ComplaintNavItem : React.FC<ComplaintNavItemProps & NavItemProps> = (props: ComplaintNavItemProps & NavItemProps) => {
  let count = props.complaintCount && props.complaintCount.count ? props.complaintCount.count : 0
  count = props.complaintCount && props.complaintCount.internalCount ? props.complaintCount.internalCount + count : count
  
  return <NavItem
    notification={count}
    {...props}
  />
}

const mapStateToProps = (state: AppState) => ({
  complaintCount: state.updateComplaintCount.complaintCount
})

export default connect(mapStateToProps, null)(ComplaintNavItem)